import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "AvailableFrameworkCategories";

export const keys = addTranslations(RESOURCE_NAME, {
    title: {
        en: "Frameworks",
        fr: "Référentiels",
    },
    card_tag: {
        en: "Active",
        fr: "Activé",
    },
    card_tag_activate: {
        en: "Active",
        fr: "Activé",
    },
    card_tag_inactive: {
        en: "Inactive",
        fr: "Inactif",
    },
    card_cta: {
        en: "See projects",
        fr: "Voir les projets",
    },
    card_cta_learn_more: {
        en: "Learn more",
        fr: "En savoir plus",
    },
    card_cta_see_projects: {
        en: "See projects",
        fr: "Voir les projets",
    },
    card_cta_request_access: {
        en: "Request access",
        fr: "Demander l'accès",
    },
    card_cta_edit_legacy: {
        en: "Edit",
        fr: "Modifier",
    },
    card_cta_edit_latest: {
        en: "Edit latest",
        fr: "Dernier projet",
    },
    card_cta_create_project: {
        en: "Create project",
        fr: "Créer un projet",
    },
});

export function useAvailableFrameworkCategoriesTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return {
        t,
        keys,
    };
}
